import { initPageCollect, reportUrl } from '@tencent/smp-tools';
import { UButton, UImage } from '@tencent/smp-ui';
import React from 'react';
import queryString from 'query-string';
import { sceneMap } from './scene';
import './index.scss';
import { launchApp } from './qb-tool';

class Index extends React.Component {
  constructor() {
    super();
    this.state = window.RENDER_DATA || {
      "pageId": "904259",
      "profile": 0,
      "contentId": 652237,
      "modeId": 1207,
      "trackingurl": null,
      "oastext": null,
      "btn": {
          "id": 27787,
          "data": {
              "init": "下载QQ浏览器",
              "loading": "下载中",
              "downloaded": "下载完成",
              "installed": "打开QQ浏览器领取",
              "downloadPause": "已取消下载，重新下载",
              "downloadFail": "下载失败",
              "installing": "正在安装"
          },
          "style": {
              "outer": {
                  "backgroundImage": "url(\"https://smpimg-1258344701.file.myqcloud.com/smpreal/SMP_20231207_2023689.png\")",
                  "backgroundSize": "100% auto",
                  "backgroundPosition": "center top",
                  "backgroundRepeat": "no-repeat",
                  "marginTop": "0px",
                  "marginRight": "0px",
                  "marginBottom": "0px",
                  "marginLeft": "0px",
                  "paddingTop": "0px",
                  "borderStyle": "none",
                  "position": "relative",
                  "bottom": null,
                  "left": "96px",
                  "right": "104px",
                  "textAlign": "center",
                  "fontWeight": "normal",
                  "fontSize": "16px",
                  "lineHeight": "104px",
                  "width": "578px",
                  "height": "198px",
                  "display": "inline-block",
                  "top": "1140px",
                  "zIndex": 10,
                  "paddingBottom": "0px",
                  "color": "#FFFFFF",
                  "backgroundColor": "rgba(255, 255, 255, 0)"
              },
              "text": {
                  "textAlign": "center",
                  "fontWeight": "bolder",
                  "fontSize": "38px",
                  "lineHeight": "78px",
                  "letterSpacing": 0,
                  "color": "#FFFFFF",
                  "marginTop": "8px",
                  "marginRight": "auto",
                  "marginBottom": "8px",
                  "marginLeft": "auto"
              }
          },
          "animation": {},
          "event": {
              "outer": [
                  {
                      "type": "click",
                      "action": "alert"
                  }
              ]
          },
          "key": "btn"
      },
      "bg": {
          "id": 27786,
          "data": {
              "image": "https://smpimg-1258344701.file.myqcloud.com/smpreal/SMP_20240826_3970684.png"
          },
          "style": {
              "image": {
                  "width": "750px"
              }
          },
          "animation": {},
          "event": [],
          "key": "bg"
      },
      "app": {
          "appid": "",
          "wxAppid": "",
          "qqAppid": "",
          "appkey": "mttbrowser",
          "filename": "QQ浏览器.apk",
          "packagename": "com.tencent.mtt",
          "appStore": "https://mdc.html5.qq.com/directdown?app=qqbrowser&channel=1100125176",
          "appId": "",
          "channelId": "1100125176",
          "url": "https://mdc.html5.qq.com/directdown?app=qqbrowser&channel=1100125176",
          "copyurl": "MTTDATA1J3iGHL9jcpfAPQ5/pOTE2v6Po7rTZa6YhjTIDjwzFWLiL/hLuux8vIvUbTfs41VYZOehNxxV13dJLs5ZEw9dR5d51BmSUiphh/CirYgVvA9PrxC9aGB+QvMsPVrkfvA4AEip9ODcjvx3fsfXMBmCYkhrLYI4txvrdRzkrJwVI0HW9T54q138bIDIgymBlS8S1Cw6vAYDamASYGQpDNFx51+sw0FTriqDy/XZPu0OXI/RK7k9ezT8eyVSMBFlGy9JlfQbkbwmzMf4HwwELr2MJ1LNRrW1q3n4dECe+HvUVJ52v4zHP940t9x5Vs2q/5zbwuw7R72SSpJKkRoUJo+NzZj+ccTMZBSC+A2l0PAp2KYJopTzbhIf5s58migJ0tI8oyDyg+pPFYJGAKIHUoDQYKICIPdarteP+GWHjBtNzpR5TfJf0bn39rxER7q2Q8XCb/YIo+3R06AERWmu2/DbQCa1cLGVNbGkwJdxmZa7SluHjs9Rs5/xM7W30itgAPYmHDiNktArO9qDqQbOVKlL7rk7wMmmrC8dJ80NzlQ7GFuX/iO0TlSza0MjIvlRVOAue6cWNUfaamQHwPW0bzYH8gAky1yyVg5M0WJmsDdNLAGMWHDTh6PfwCnp08mGpJ9+qLggGZ5ZirWFoFoTpVyTYI7B0yBMbgQfHpNvfAoqMdCnE3X6w954sZYrDIGNwWZ8DGmDjw4MkZennayZhPBfoDUV8uxltzTZ70esd1iZOcgN0UlIirvXVnmXY6f6AEzwvi1MlgmCRe2CqF1SPU8Qw==",
          "active": "mttbrowser://url=qb://ext/rn?component=commonpay&module=commonpay&page=toolsLandingpage&coverToolbar=true&orientation=1&appid=tool&scene=acquisition&actId=a6ABcdFrP&fromid=tool1024&bvEnd=140&channel=searchcard4,ChannelID=sgwap_lh,PosID=92141",
          "autoOpen": false,
          "key": "app",
          "originCopyurl": "mttbrowser://url=qb://ext/rn?component=commonpay&module=commonpay&page=toolsLandingpage&coverToolbar=true&orientation=1&appid=tool&scene=acquisition&actId=a6ABcdFrP&fromid=tool1024&bvEnd=140&channel=searchcard4,ChannelID=sgwap_lh,PosID=92141"
      },
      "page": {
          "bg": "#FFFFFF",
          "title": "上QQ浏览器看影视动画"
      },
      "stat": "https://ustat.html5.qq.com/stat?st=BgoyMDI0MDkxNDIwFg8xNjMuMTI1LjIxNy4xNjImADYARgBWBjkwNDI1OWYEMTIwN3YGNjUyMjM3hgCWKnsicWltZWkzNiI6IiIsImd1aWQiOiIiLCJpbWVpIjoiIiwicXEiOiIifaYAtgDGANYA5gD2DwD2EIVNb3ppbGxhLzUuMCAoTGludXg7IEFuZHJvaWQgOC4wLjA7IFNNLUc5NTVVIEJ1aWxkL1IxNk5XKSBBcHBsZVdlYktpdC81MzcuMzYgKEtIVE1MLCBsaWtlIEdlY2tvKSBDaHJvbWUvMTE2LjAuMC4wIE1vYmlsZSBTYWZhcmkvNTM3LjM29hFZeyJyZW1vdGVpcCI6IjE2My4xMjUuMjE3LjE2MiIsImlwIjoiMTYzLjEyNS4yMTcuMTYyIiwicmVhbGlwIjoiMTYzLjEyNS4yMTcuMTYyIiwiaXBzIjpbXX32EgA="
  };
  }

  handleReport({ action = '', subkey = '' }) {
    const { stat = '' } = this.state;
    reportUrl?.({
      statUrl: stat,
      action,
      subkey,
    });
  }

  componentDidMount() {
    const { stat = '' } = window.RENDER_DATA || {};

    const search = queryString.parse(location.search) || {};
    const queryScene = search.scene || 'normal';
    const sceneInfo = sceneMap[queryScene];
    window.document.title = sceneInfo.title || '快来下载QQ浏览器';

    initPageCollect({
      statUrl: stat,
    });

    setTimeout(async () => {
      await launchApp();
    }, 300);
  }

  getAppLinkInfo() {
    // 默认走‘QQ浏览器'
    return {
      appname: 'QQ浏览器',
      qbversion: window.qbversion || '15.9.5',
      qbupdatetime: window.qbupdatetime || '2025/01/08',
      developer: '深圳市腾讯计算机系统有限公司',
      access:
        'https://rule.tencent.com/rule/preview/75617252-b1ba-44a7-95ab-d8a478b859dc',
      privacy:
        'https://privacy.qq.com/document/preview/2491347092a64d7fa00cbc2bf68fbbbb',
    };
  }

  handleClick() {
    const { app, stat = '' } = this.state;

    if (app.active) {
      const search = queryString.parse(location.search) || {};
      const deeplink = app.active.replace(/__SEARCH_QUERY__/gi, encodeURIComponent(search.query));
      const url = `${stat}&action=ugreport&subkey=&deeplink=${encodeURIComponent(deeplink)}`;
      new Image().src = url;
    }
  }

  renderAppInfo() {
    const { appStatus } = this.state;
    const { app = {} } = window.RENDER_DATA || {};

    if (appStatus === 6) {
      return null;
    }

    const appInfo = this.getAppLinkInfo(app.packagename);
    const { appname, qbversion, qbupdatetime, developer, access, privacy } =
      appInfo;

    return (
      <div
        style={{
          fontSize: 10,
          margin: 0,
          padding: 6,
          textAlign: 'center',
          width: '100%',
          background: '#fff',
          bottom: 0,
          zIndex: 10000,
        }}
      >
        <div style={{ margin: 0, padding: 2, height: 18, overflow: 'hidden' }}>
          <span style={{ paddingRight: 4 }}>
            应用名称：{appname} 版本：{qbversion}
          </span>
          <span>更新时间：{qbupdatetime}</span>
        </div>
        <div style={{ margin: 0, padding: 2, height: 18, overflow: 'hidden' }}>
          开发者：{developer} &nbsp;
          <a
            style={{ color: 'gray', textDecoration: 'underline' }}
            href={access}
          >
            权限信息
          </a>{' '}
          &nbsp;
          <a
            style={{ color: 'gray', textDecoration: 'underline' }}
            href={privacy}
          >
            隐私协议
          </a>
          &nbsp;
          <a
            style={{ color: 'gray', textDecoration: 'underline' }}
            href="https://rule.tencent.com/rule/preview/d7b6c1cb-d5b7-4c31-916a-35b4e48ec40f"
          >
            产品功能
          </a>
        </div>
      </div>
    );
  }

  render() {
    const { app, bg, btn, stat } = this.state;
    const search = queryString.parse(location.search) || {};

    const finalAppActive = app.active ? app.active.replace(
      /__SEARCH_QUERY__/gi,
      encodeURIComponent(search.query)
    ) : null;

    // 合规要求
    const formatApp = {
      ...app,
      appkey: 'mttbrowser',
      filename: 'QQ浏览器.apk',
      packagename: 'com.tencent.mtt',
      active: finalAppActive,
      fileIcon: 'http://pp.myapp.com/ma_icon/0/icon_11384_1587715513/256',
      auto: false,
      autoActive: false,
      autoOpen: false,
      canpause: true,
    };
    return (
      <div className="App">
        <div className="img-cont">
          <UImage ui={bg} />
        </div>
        <UButton
          ui={btn}
          app={formatApp}
          stat={stat}
          onBtnClick={() => this.handleClick()}
        />
        <div className="fixed-footer">{this.renderAppInfo()}</div>
      </div>
    );
  }
}
export default Index;
